import * as React from "react";
import { Button } from "./Button";
import ACTIONS from "./EventLibrary";
import { rudderStackTrack } from "./Track";

export function DiscordCTA({ displayName }) {

    return <div className="cta">
        <div className="content">
            <h3>Want To Level Up Your Data Analytics Skills?</h3>
            <p />
            {displayName ? <p>Join now {displayName}.</p> : ""}
            <p>Grow your skills in blockchain analytics alongside 100s of Web3 analysts!</p>
            <Button onClick={() => { rudderStackTrack(ACTIONS.docs_discordcta_clicked, { value: "https://discord.gg/Q4FmJBmB" }); }} target="_blank" rel="noreferrer noopener" href={"https://www.covalenthq.com/data-alchemist/"}>Join Now</Button>
        </div>
        <style jsx>
            {`            
            .cta {
                padding: 0.5rem 0 2rem;
            }
            h3 {
                margin-top: 0rem;
                margin-bottom: 1rem;
            }
            .content {
                color: var(--dark);
                background: var(--code-background);
                border: 1px solid var(--code-border);
                line-height: 20px;
                padding: 12px 20px;
                border-radius: var(--border-radius);
              }
              .cta :global(p:first-of-type) {
                padding: 0;
              }
    
            `}
        </style>
    </div>;
}
